(function(){
  'use strict';

  const CC = {
    storageKey(version){ return `rm_cc_prefs_v${version||'1'}`; },
    version: (window.themeSettings && window.themeSettings.cookieConsentVersion) || 1,
    policyUrl: (window.themeSettings && window.themeSettings.cookiePolicyUrl) || '/policies/privacy-policy',
    enabled: true,
    texts: {
      message: 'This website uses cookies to ensure you get the best experience.',
      learnMore: 'Learn more',
      acceptAll: 'Accept',
      rejectAll: 'Reject all',
      preferences: 'Preferences',
      save: 'Save preferences'
    }
  };

  // Best-effort purge of cookies for categories that are NOT allowed.
  // Note: Third-party HttpOnly cookies cannot be removed via JS; this removes
  // first-party cookies and attempts common domain variants.
  function purgeCookiesForPrefs(prefs){
    try {
      const all = (document.cookie || '').split(';').map(s=>s.trim()).filter(Boolean);
      if (!all.length) return;
      const disallowed = function(name){
        const cat = classifyCookie(name || '');
        if (cat === 'analytics' && prefs.analytics !== true) return true;
        if (cat === 'marketing' && prefs.marketing !== true) return true;
        if (cat === 'preferences' && prefs.preferences !== true) return true;
        return false;
      };
      
      const host = location.hostname;
      const parts = host.split('.');
      const domains = [undefined];
      for (let i=0; i<parts.length-1; i++){
        domains.push('.' + parts.slice(i).join('.'));
      }
      all.forEach(kv => {
        const name = kv.split('=')[0];
        if (!disallowed(name)) return;
        domains.forEach(d => {
          try {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/` + (d?`; domain=${d}`:'');
          } catch(_){}
        });
      });
    } catch(_){}
  }

  function shouldReload(prev, next){
    try {
      if (!prev) return false;
      const cats = ['analytics','marketing','preferences'];
      return cats.some(k => prev[k] === true && next[k] === false);
    } catch(_) { return false; }
  }

  function enableQueuedScripts(prefs){
    try {
      const nodes = document.querySelectorAll('script[type="text/plain"][data-cc]:not([data-cc-executed])');
      nodes.forEach(function(s){
        const cat = s.getAttribute('data-cc');
        if (!cat || !prefs[cat]) return;
        const t = document.createElement('script');
        // copy basic attributes
        ['async','defer','crossorigin','referrerpolicy','nonce'].forEach(attr=>{
          if (s.hasAttribute(attr)) t.setAttribute(attr, s.getAttribute(attr));
        });
        const src = s.getAttribute('data-src') || s.getAttribute('src');
        if (src) t.src = src;
        else t.text = s.textContent || '';
        s.replaceWith(t);
        s.setAttribute('data-cc-executed','1');
      });
    } catch(err){ /* no-op */ }
  }

  function readSettingsFromDOM(){
    try {
      const el = document.querySelector('[data-cookie-consent-settings]');
      if (!el) return;
      const data = JSON.parse(el.textContent || '{}');
      CC.version = data.version || CC.version;
      CC.policyUrl = data.policyUrl || CC.policyUrl;
      CC.enabled = !!data.enabled;
      CC.texts = Object.assign({}, CC.texts, data.texts || {});
    } catch(err){ console.warn('CookieConsent: settings parse failed', err); }
  }

  function getStored(){
    try {
      const raw = localStorage.getItem(CC.storageKey(CC.version));
      if (!raw) return null;
      return JSON.parse(raw);
    } catch(err){ return null; }
  }

  function store(prefs){
    try {
      localStorage.setItem(CC.storageKey(CC.version), JSON.stringify(prefs));
    } catch(err){}
  }

  function ensurePrivacyAPI(cb){
    if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.setTrackingConsent === 'function'){
      return cb(Shopify.customerPrivacy);
    }
    if (window.Shopify && typeof Shopify.loadFeatures === 'function'){
      Shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1' }
      ], function(error){
        if (!error && Shopify.customerPrivacy){ return cb(Shopify.customerPrivacy); }
        cb(null);
      });
      return;
    }
    cb(null);
  }

  function setConsent(prefs, done){
    ensurePrivacyAPI(function(api){
      if (api){
        // Map categories to Shopify consent object
        const payload = {
          analytics: !!prefs.analytics,
          marketing: !!prefs.marketing,
          preferences: !!prefs.preferences,
          // necessary/functional are always allowed and not configurable
        };
        try {
          api.setTrackingConsent(payload, function(){ done && done(true); });
          return;
        } catch(err){ /* fallback below */ }
      }
      done && done(false);
    });
  }

  function show(el){ el && (el.style.display = 'block'); }
  function hide(el){ el && (el.style.display = 'none'); }

  function openModal(){
    const modal = document.getElementById('ccModal');
    const sheet = modal && modal.querySelector('.cookie-consent__sheet');
    const bannerCard = document.querySelector('#ccBanner .cookie-consent__card');
    // Prime animation from banner size
    if (sheet && bannerCard) {
      const rect = bannerCard.getBoundingClientRect();
      sheet.style.width = rect.width + 'px';
      sheet.style.maxHeight = Math.max(220, rect.height) + 'px';
    }
    show(modal);
    // Next frame -> expand
    requestAnimationFrame(function(){
      if (sheet) {
        sheet.classList.add('is-open');
        // Let CSS target width/max-height take over
        // Use a small timeout so transition animates width to clamp value
        setTimeout(function(){
          sheet.style.width = '';
          sheet.style.maxHeight = '';
        }, 30);
      }
    });
    // If there are no stored preferences, default all toggles ON
    const existing = getStored();
    if (!existing) setModalToggles({ analytics: true, marketing: true, preferences: true });
    // Prevent toggle clicks from expanding details
    try {
      const toggles = modal.querySelectorAll('.rm-toggle');
      toggles.forEach(function(toggle){
        toggle.addEventListener('click', function(e){ 
          e.stopPropagation(); 
        });
      });
    } catch(err) { /* no-op */ }
  }
  function closeModal(){
    const modal = document.getElementById('ccModal');
    const sheet = modal && modal.querySelector('.cookie-consent__sheet');
    if (sheet) {
      sheet.classList.remove('is-open');
    }
    hide(modal);
  }

  function bindEvents(){
    const banner = document.getElementById('ccBanner');
    if (!banner) return;

    const btnAccept = banner.querySelector('[data-cc-accept]');
    const btnPrefs = banner.querySelector('[data-cc-prefs]');
    const btnReject = banner.querySelector('[data-cc-reject]');

    btnAccept && btnAccept.addEventListener('click', function(){
      const prefs = { analytics: true, marketing: true, preferences: true, necessary: true };
      setConsent(prefs, function(){ store(prefs); enableQueuedScripts(prefs); hide(banner); document.dispatchEvent(new CustomEvent('rm:cookie-consent', { detail: Object.assign({ accepted: true }, prefs) })); });
    });

    btnReject && btnReject.addEventListener('click', function(){
      const prefs = { analytics: false, marketing: false, preferences: false, necessary: true };
      setConsent(prefs, function(){ store(prefs); hide(banner); document.dispatchEvent(new CustomEvent('rm:cookie-consent', { detail: Object.assign({ accepted: false }, prefs) })); });
    });

    btnPrefs && btnPrefs.addEventListener('click', function(){ openModal(); });

    // Modal controls
    const modal = document.getElementById('ccModal');
    if (!modal) return;
    modal.addEventListener('click', function(e){ if (e.target === modal) closeModal(); });
    const btnClose = modal.querySelector('[data-cc-close]');
    btnClose && btnClose.addEventListener('click', closeModal);

    // Prevent toggle clicks from expanding details
    try {
      const toggles = modal.querySelectorAll('.rm-toggle');
      toggles.forEach(function(toggle){
        toggle.addEventListener('click', function(e){ 
          e.stopPropagation(); 
        });
      });
    } catch(err) { /* no-op */ }

    const btnSave = modal.querySelector('[data-cc-save]');
    const btnAcceptAll = modal.querySelector('[data-cc-accept-all]');
    const btnRejectAll = modal.querySelector('[data-cc-reject-all]');

    btnAcceptAll && btnAcceptAll.addEventListener('click', function(){
      const prev = getStored();
      const prefs = { analytics: true, marketing: true, preferences: true, necessary: true };
      // Reflect in UI immediately
      setModalToggles({ analytics: true, marketing: true, preferences: true });
      setConsent(prefs, function(){
        store(prefs);
        enableQueuedScripts(prefs);
        closeModal();
        hide(banner);
        document.dispatchEvent(new CustomEvent('rm:cookie-consent', { detail: Object.assign({ accepted: true }, prefs) }));
        // No reload needed when increasing permissions
      });
    });
    btnRejectAll && btnRejectAll.addEventListener('click', function(){
      const prev = getStored();
      const prefs = { analytics: false, marketing: false, preferences: false, necessary: true };
      setModalToggles({ analytics: false, marketing: false, preferences: false });
      setConsent(prefs, function(){
        store(prefs);
        purgeCookiesForPrefs(prefs);
        closeModal();
        hide(banner);
        document.dispatchEvent(new CustomEvent('rm:cookie-consent', { detail: Object.assign({ accepted: false }, prefs) }));
        if (shouldReload(prev, prefs)) { setTimeout(function(){ location.reload(); }, 150); }
      });
    });

    btnSave && btnSave.addEventListener('click', function(){
      const prev = getStored();
      const prefs = collectModalToggles();
      const decreased = shouldReload(prev, prefs);
      setConsent(prefs, function(){
        store(prefs);
        if (prefs.analytics || prefs.marketing || prefs.preferences) {
          enableQueuedScripts(prefs);
        }
        if (decreased) { purgeCookiesForPrefs(prefs); }
        closeModal();
        hide(banner);
        document.dispatchEvent(new CustomEvent('rm:cookie-consent', { detail: Object.assign({ accepted: !!(prefs.analytics||prefs.marketing||prefs.preferences) }, prefs) }));
        if (decreased) { setTimeout(function(){ location.reload(); }, 150); }
      });
    });
  }

  function setModalToggles(values){
    const m = document.getElementById('ccModal');
    if (!m) return;
    const map = {
      analytics: m.querySelector('#cc-toggle-analytics'),
      marketing: m.querySelector('#cc-toggle-marketing'),
      preferences: m.querySelector('#cc-toggle-preferences')
    };
    Object.keys(values).forEach(k=>{ if(map[k]) map[k].checked = !!values[k]; });
  }
  function collectModalToggles(){
    const m = document.getElementById('ccModal');
    return {
      necessary: true,
      preferences: !!(m.querySelector('#cc-toggle-preferences')||{}).checked,
      analytics: !!(m.querySelector('#cc-toggle-analytics')||{}).checked,
      marketing: !!(m.querySelector('#cc-toggle-marketing')||{}).checked,
    };
  }

  function populateCookieTables(){
    const data = detectCookies();
    const sections = [
      { id: 'cc-table-preferences', list: data.preferences },
      { id: 'cc-table-analytics', list: data.analytics },
      { id: 'cc-table-marketing', list: data.marketing }
    ];
    sections.forEach(sec => {
      const table = document.getElementById(sec.id);
      if (!table) return;
      const tbody = table.querySelector('tbody');
      if (!tbody) return;
      tbody.innerHTML = '';
      (sec.list && sec.list.length ? sec.list : [{ name: '—', provider: '—', purpose: '—', expiry: '—' }]).forEach(row => {
        const tr = document.createElement('tr');
        tr.innerHTML = `<td>${escapeHTML(row.name)}</td><td>${escapeHTML(row.provider||'-')}</td><td>${escapeHTML(row.purpose||'-')}</td><td>${escapeHTML(row.expiry||'-')}</td>`;
        tbody.appendChild(tr);
      });
    });
  }

  function escapeHTML(s){ return String(s||'').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;'}[c])); }

  function detectCookies(){
    const all = (document.cookie || '').split(';').map(s=>s.trim()).filter(Boolean);
    const list = all.map(kv => ({ name: kv.split('=')[0], provider: guessProvider(kv), purpose: guessPurpose(kv), expiry: 'Session/Defined' }));
    const byCat = { necessary: [], preferences: [], analytics: [], marketing: [] };
    list.forEach(item => {
      const cat = classifyCookie(item.name);
      byCat[cat].push(item);
    });
    return byCat;
  }

  function classifyCookie(name){
    const n = name.toLowerCase();
    // Shopify essential and functional
    if (/(^|_)cart(_|$)|(^|_)secure_customer_sig|(^|_)storefront_digest|(^|_)shopify|(^|_)checkout|(^|_)localization/.test(n)) return 'necessary';
    // Preferences
    if (/locale|currency|pref|consent|cookieconsent|twic_state/.test(n)) return 'preferences';
    // Analytics (GA, Mixpanel, etc.)
    if (/^_ga|^_gid|^_gcl|^_gat|^mp_|^ajs_/.test(n)) return 'analytics';
    // Marketing (FB, TikTok, Klaviyo, Snapchat)
    if (/^_fbp|^_fbc|^_ttp|^tt_webid|^_sc|^sc_/.test(n)) return 'marketing';
    // Default to analytics for unknown third-party patterns
    return 'analytics';
  }

  function guessProvider(kv){
    const n = kv.split('=')[0].toLowerCase();
    if (/^_ga|^_gid|^_gcl|^_gat/.test(n)) return 'Google Analytics';
    if (/^_fbp|^_fbc/.test(n)) return 'Meta/Facebook';
    if (/^_ttp|^tt_/.test(n)) return 'TikTok';
    if (/^_sc|^sc_/.test(n)) return 'Snapchat';
    if (/^__kla|^kla_/.test(n)) return 'Klaviyo';
    if (/(^|_)shopify/.test(n)) return 'Shopify';
    return '—';
  }

  function guessPurpose(kv){
    const n = kv.split('=')[0].toLowerCase();
    if (/^_ga|^_gid|^_gcl|^_gat/.test(n)) return 'Analytics & performance';
    if (/^_fbp|^_fbc|^_ttp/.test(n)) return 'Advertising & retargeting';
    if (/(^|_)cart(_|$)/.test(n)) return 'Cart functionality';
    if (/localization|currency/.test(n)) return 'Localization & preferences';
    if (/(^|_)secure_customer_sig|storefront_digest/.test(n)) return 'Authentication & security';
    return '';
  }

  function init(){
    readSettingsFromDOM();
    if (!CC.enabled) return;
    const existing = getStored();
    if (!existing){
      show(document.getElementById('ccBanner'));
    } else {
      // Set consent on load to ensure Shopify state is synced
      setConsent(existing, function(){ enableQueuedScripts(existing); document.dispatchEvent(new CustomEvent('rm:cookie-consent', { detail: Object.assign({ accepted: true }, existing) })); });
    }
    bindEvents();
    populateCookieTables();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
